<template>
  <div>
    <div
      class="group-input col-12 column q-mt-sm"
      v-if="numericTypeOs === PREDIO_SEM_BACKBONE"
    >
      <div class="row">
        <label>O imóvel se encontra em trecho de rua não cabeada?</label>
      </div>
      <div class="flex row justify-around">
        <q-radio
          keep-color
          v-model="itemOsContract.rua_nao_cabeada"
          size="lg"
          :val="1"
          label="Sim"
          color="red-6"
        />
        <q-radio
          keep-color
          size="lg"
          v-model="itemOsContract.rua_nao_cabeada"
          :val="0"
          label="Não"
          color="red-6"
        />
      </div>
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Quantidade de bloco(s)"
        name="quantidade_bloco"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        name="quantidade_bloco"
        input-debounce="0"
        type="number"
        placeholder="Digite aqui"
        v-model="itemOsContract.quantidade_bloco"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Quantidade de andares"
        name="quantidade_andar"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        v-model="itemOsContract.quantidade_andar"
        type="number"
        name="quantidade_andar"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Quantidade de apartamentos por andar"
        name="quantidade_ap_por_andar"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        type="number"
        color="red-9"
        use-input
        v-model="itemOsContract.quantidade_ap_por_andar"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="quantidade_ap_por_andar"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div
      class="group-input col-12 row q-mt-sm"
      v-if="numericTypeOs === NAP_LOTADA_MDU"
    >
      <RequiredLabel
        title="Imóveis conectados ao splitter ideal"
        name="imoveis_conectados_ao_splitter"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.imoveis_conectados_ao_splitter"
        type="number"
        name="imoveis_conectados_ao_splitter"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Nome do síndico / zelador"
        name="nome_sindico_zelador"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        name="nome_sindico_zelador"
        v-model="itemOsContract.nome_sindico_zelador"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Telefone para contato síndico / zelador"
        name="telefone_sindico_zelador"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.telefone_sindico_zelador"
        :type="
          numericTypeOs === PREDIO_SEM_BACKBONE ||
          numericTypeOs === SERVICO_CONCLUIDO_MDU
            ? 'number'
            : 'text'
        "
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        name="telefone_sindico_zelador"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div
      class="group-input col-12 row q-mt-sm"
      v-if="numericTypeOs === NAP_LOTADA_MDU"
    >
      <RequiredLabel
        title="Quantidade de imóveis conectados na NAP"
        name="qtd_imoveis_conectados_nap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        type="number"
        color="red-9"
        v-model="itemOsContract.qtd_imoveis_conectados_nap"
        name="qtd_imoveis_conectados_nap"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import {
  NAP_LOTADA_MDU,
  PREDIO_SEM_BACKBONE,
  SERVICO_CONCLUIDO_MDU,
} from "@/utils/constans/specialCodes";
import { inject, onBeforeMount } from "vue";

  export default {
    name: "MduNapForm",
    components: {
      RequiredLabel,
    },
    props: {
      itemOsContract: Object,
      typeOs: Number,
    },

    setup(props, { emit }) {
      const addFieldsToRequestData = inject("addFieldsToRequestData");
      const numericTypeOs = Number(props.typeOs);

      let formFields = {
        quantidade_bloco: "",
        quantidade_andar: "",
        quantidade_ap_por_andar: "",
        nome_sindico_zelador: "",
        telefone_sindico_zelador: "",
      };

      let NapLotadaForm = {
        ...formFields,
        imoveis_conectados_ao_splitter: "",
        qtd_imoveis_conectados_nap: "",
      };

      let buildingWithouthBackboneForm = {
        ...formFields,
        rua_nao_cabeada: 0,
      };

      const fieldsMapper = {
        [PREDIO_SEM_BACKBONE]: buildingWithouthBackboneForm,
        [NAP_LOTADA_MDU]: NapLotadaForm,
        [SERVICO_CONCLUIDO_MDU]: formFields,
      };

      onBeforeMount(() => {
        let newFields = fieldsMapper[numericTypeOs];
        addFieldsToRequestData(newFields);
      });
      return {
        numericTypeOs,
        NAP_LOTADA_MDU,
        PREDIO_SEM_BACKBONE,
        SERVICO_CONCLUIDO_MDU,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }
  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
